import { useMemo } from "react";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { CarSearch, useCarAvailabilitySearch } from "@tenant/cars";
import {
  Button,
  ButtonTypeEnum,
  Dialog,
  DialogContent,
  DialogTrigger,
  Icon,
  useControlledDialog,
} from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./CarAvailabilitySearch.module.scss";
import { useCarsStyles } from "~core-cars/themes";
import { CoreCarsComponent } from "~core-cars/types";

export type CarAvailabilitySearchProps = PlatformComponentProps;

const COMPONENT_KEY = CoreCarsComponent.CarAvailabilitySearch;
export const CarAvailabilitySearch = ({
  className,
}: CarAvailabilitySearchProps) => {
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { context, handlers } = useCarAvailabilitySearch();

  const search = useMemo(
    () => (
      <CarSearch
        onSubmitAppend={() => handlers.onSearch()}
        className={cn("search")}
      />
    ),
    [cn, handlers]
  );

  return (
    <div className={clsx(block, className)}>
      <div className={cn("full-search")}>{search}</div>
      <Dialog modal={false} {...context.dialogProps.props}>
        <DialogTrigger asChild>
          <Button
            buttonType={ButtonTypeEnum.Wrap}
            className={cn("search-dialog")}
          >
            <div className={cn("icon")}>
              <Icon iconName={IconNameEnum.search} />
            </div>
            {context.search != null ? (
              <div className={cn("content")}>
                <div className={cn("search-button-label")}>
                  {context.search.location}
                </div>
                <div className={cn("search-button-value")}>
                  {context.search.summary}
                </div>
              </div>
            ) : null}
          </Button>
        </DialogTrigger>
        <DialogContent fullScreen={true}>{search}</DialogContent>
      </Dialog>
    </div>
  );
};
